export function createBasketRecommendationsQuery(
  offer,
  buyerAccountId,
  isBunkering,
  isContract,
  isDeliveredIn = false,
  deliveredInData = {},
  includeAuditTrail = false
) {
  const query = {
    sellerAccountIds: [offer.seller._id],
    platform: "OLFUK",
    includeAuditTrail,
  };
  if (buyerAccountId) {
    query.buyerAccountId = buyerAccountId;
  }

  if (isBunkering) {
    query.queryType = isContract ? "CONTRACT_BUNK" : "BUNK";
    query.networks = [offer.networkId];
  } else if (!isBunkering) {
    query.queryType = "EX";
    query.terminals = [offer.terminal_id];
    query.days = offer.collectionTime;
    query.liftingPeriod = offer.liftingPeriod;

    if (isContract) {
      query.queryType = "CONTRACT_EX";
    } else if (isDeliveredIn) {
      query.queryType = "DIN";
      query.postcode = deliveredInData.location.postCode;
      query.days = deliveredInData.deliveryDate;
    }
  }
  // Add brand's object ID to the query if the contract offer is branded
  const isBrandedContract = isContract && offer.meta && offer.meta.integration && offer.meta.integration.brand;
  if (isBrandedContract) query.brandId = offer.meta.integration.brand.brandReferenceId;

  return query;
}

export function buildOrderCaptureBasketItemObject(
  _id,
  fuel_id,
  quantity,
  quotePrice,
  totalPrice,
  adjustment,
  fuel_measurement_id,
  networkId,
  terminal_id,
  price,
  collectionTime,
  liftingPeriod,
  seller,
  pricingAuditTrail,
  maximumAvailable = null,
  currentMaximumAvailable = null,
  minimumOrderQuantity = null,
  isOfferAvailable = true,
  offerReference = null
) {
  return {
    _id,
    fuel_id,
    quantity,
    quotePrice,
    totalPrice,
    adjustment,
    fuel_measurement_id,
    networkId,
    reference: offerReference,
    terminal_id,
    price,
    collectionTime,
    liftingPeriod,
    seller,
    pricingAuditTrail,
    maximumAvailable,
    currentMaximumAvailable,
    minimumOrderQuantity,
    isOfferAvailable,
  };
}
